"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = isCancellationError;

function isCancellationError(error) {
  return ['backdrop', 'overlay', 'cancel', 'close', 'esc', 'timer'].indexOf(error) !== -1;
}